export default __webpack_public_path__ + "static/media/paris.88d8b7c6.jpg";